export const CORPORATION = process.env.REACT_APP_CORP;
export const ENV = process.env.REACT_APP_ENV;
